export const localizedProviderTitleId = (title) => {
    const lettersOnly = title.replace(/\./gi, '') || 'Other';
    return `user.titles.${lettersOnly}`;
};
